import { PageTitle } from '@sleepstation/components'
import { VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN } from '@sleepstation/const'
import {
  mq,
  padding,
  propToBackgroundColor,
} from '@sleepstation/style-api-helpers'
import { reversedTheme } from '@sleepstation/themes-public-site'
import { rem } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import styled, { ThemeProvider } from 'styled-components'
import { DBAS_LEVEL, EPWORTH_LEVEL } from '../../../../const/quiz'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const SIZE_X_SMALL = rem(120)
const SIZE_SMALL = rem(144)
const SIZE_MEDIUM = rem(144)
const SIZE_LARGE_UP = rem(156)

const LEVEL_COLOR_MAPPING = Object.freeze({
  [EPWORTH_LEVEL.POSITIVE]: `positive`,
  [EPWORTH_LEVEL.NEUTRAL]: `neutral`,
  [EPWORTH_LEVEL.NEGATIVE]: `negative`,
  [DBAS_LEVEL.HIGH]: `backgroundStart`,
  [DBAS_LEVEL.LOW]: `backgroundStart`,
  [DBAS_LEVEL.LOW_FLAGGED]: `backgroundStart`,
})

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Badge = styled.div`
  position: relative;
  flex-shrink: 0 !important;
  ${propToBackgroundColor(`level`, LEVEL_COLOR_MAPPING)}
  border-radius: 50%;
  ${padding(0.5)}
  width: ${SIZE_X_SMALL};
  height: ${SIZE_X_SMALL};

  ${mq(`smallOnly`)} {
    width: ${SIZE_SMALL};
    height: ${SIZE_SMALL};
  }

  ${mq(`mediumOnly`)} {
    width: ${SIZE_MEDIUM};
    height: ${SIZE_MEDIUM};
  }

  ${mq(`largeUp`)} {
    width: ${SIZE_LARGE_UP};
    height: ${SIZE_LARGE_UP};
  }

  > * {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    right: 0;
  }
`

const Layout = styled(VLayout).attrs({ align: LAYOUT_ALIGN.CENTER })``

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const ScoreHero = ({ score, level, formatter }) => {
  const formattedScore = formatter(score)
  return (
    <Layout>
      <ThemeProvider theme={reversedTheme}>
        <Badge level={level}>
          <PageTitle data-cy="score-title" align="center">
            {formattedScore}
          </PageTitle>
        </Badge>
      </ThemeProvider>
    </Layout>
  )
}

ScoreHero.propTypes = {
  score: PropTypes.string.isRequired,
  level: PropTypes.string.isRequired,
  formatter: PropTypes.func.isRequired,
}

export default ScoreHero
